<template>
	<v-form ref="formModeloDocumentoRevisao" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-cancelar="cancelar"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="cancelar"
		>
			<template #body>
				<v-row class="mt-1">
					<v-col cols="12">
						<label-personalizado nome-campo="Tipo" obrigatorio-por-padrao></label-personalizado>
						<v-text-field
							:value="tipoDocumento"
							counter="20"
							maxlength="20"
							type="string"
							disabled
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<label-personalizado nome-campo="Título" obrigatorio-por-padrao></label-personalizado>
						<v-text-field
							v-model="tituloDocumento"
							:rules="tituloDocumentoRules"
							counter="50"
							maxlength="50"
							type="string"
							placeholder="Informe o título"
						></v-text-field>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import Modal from '@/views/components/Modal.vue'

export default {
	name: 'modal-modelo-documento-revisao',
	components: { Modal, LabelPersonalizado },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			required: true,
		},
		tipoDocumento: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			formIsValid: false,
			tituloDocumento: null,
			tituloDocumentoRules: [
				(v) => this.regraObrigatoriedade(v, 'Título é obrigatório.'),
				(v) =>
					this.regraDeTamanhoMaximoString(
						v,
						50,
						'O campo título deve ser menor ou igual do que 50 caracteres.',
					),
			],
		}
	},
	methods: {
		confirmar() {
			if (this.$refs.formModeloDocumentoRevisao.validate()) {
				this.$emit('salvar-modelo-documento-revisao', this.tituloDocumento)
			}
		},
		cancelar() {
			this.limparModeloDocumento()
			this.$emit('fechar-modal')
		},
		limparModeloDocumento() {
			this.tituloDocumento = null
		},
	},
}
</script>

<style scoped lang="stylus"></style>
